module.exports = __webpack_public_path__ + "img/background2.0535ad41.jpg";